
<app-spinner *ngIf="utils.showLoader"></app-spinner>


<app-header></app-header>
<!-- <app-home></app-home> -->
<router-outlet></router-outlet>
<app-footer></app-footer>
<div class="tickerContainer" [ngClass]="{'tickerOnMobile':showTicker}">
  <a href="/load-calculator" [ngClass]="{'no-transform-hover': showCalcButton, 'd-none': hideCalcButton}">Load Calculator</a>
  <a href="/solar-calculator" [ngClass]="{'no-transform-hover': showCalcButton, 'd-none': hideCalcButton}">Solar Calculator</a>
  <div class="arrow" (click)="showTicker=!showTicker" [hidden]="showCalcButton || hideCalcButton"></div>
</div>
  